"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgKanbanFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4 2a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2V4a2 2 0 00-2-2H4zm4 3a1 1 0 00-1-1H5a1 1 0 00-1 1v10.001a1 1 0 001 1h2a1 1 0 001-1V5zm5-1a1 1 0 011 1v5.997a1 1 0 01-1 1h-2a1 1 0 01-1-1V5a1 1 0 011-1h2zm7 1a1 1 0 00-1-1h-2a1 1 0 00-1 1l.001 14a1 1 0 001 1h2a1 1 0 001-1L20 5z' }))); };
exports.default = SvgKanbanFilled;
//# sourceMappingURL=KanbanFilled.js.map